import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const SidebarHeader = ({ open, drawerWidth, handleDrawerToggle, theme }) => {
  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {open && (
          <Box sx={{ 
            flex: 1, 
            display: "flex", 
            justifyContent: "center",
            p: 2,
            background: "linear-gradient(135deg, rgba(255, 112, 67, 0.05) 0%, rgba(255, 112, 67, 0.02) 100%)",
            borderRadius: 3,
            mb: 1
          }}>
            <img
              src={require("../../../assets/wala.png")}
              style={{ 
                height: "70px", 
                width: "auto",
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
              }}
              alt="Logo"
            />
          </Box>
        )}
      </Box>
      <IconButton
        onClick={handleDrawerToggle}
        sx={{
          // Positioning
          position: "fixed",
          left: open ? drawerWidth - 20 : 12,
          top: 20,
          zIndex: theme.zIndex.drawer + 2,

          // Dimensions
          width: 44,
          height: 44,

          // Styling
          background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
          border: "1px solid rgba(255, 112, 67, 0.15)",
          boxShadow: "0 4px 12px rgba(255, 112, 67, 0.15), 0 2px 6px rgba(0, 0, 0, 0.08)",
          backdropFilter: "blur(10px)",

          // Animation
          transition: theme.transitions.create(["left", "transform", "box-shadow"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),

          // Hover state
          "&:hover": {
            background: "linear-gradient(135deg, #ffffff 0%, #fff3e0 100%)",
            boxShadow: "0 6px 16px rgba(255, 112, 67, 0.2), 0 4px 8px rgba(0, 0, 0, 0.12)",
            transform: "scale(1.05)",
            borderColor: "rgba(255, 112, 67, 0.25)",
          },

          "&:active": {
            transform: "scale(0.95)",
          },
        }}
      >
        {open ? (
          <ChevronLeftIcon sx={{ color: theme.palette.primary.main }} />
        ) : (
          <Typography
            variant="h6"
            sx={{
              fontSize: "22px",
              fontWeight: 700,
              color: theme.palette.primary.main,
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              textShadow: "0 1px 2px rgba(255, 112, 67, 0.3)",
            }}
          >
            W
          </Typography>
        )}
      </IconButton>
    </>
  );
};

SidebarHeader.propTypes = {
  open: PropTypes.bool.isRequired,
  drawerWidth: PropTypes.number.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
};

export default SidebarHeader;
